import React, { Component } from 'react'
import PropTypes from 'prop-types'

import TopsSync from './TopsSync'
import DolphinSync from './DolphinSync'
import OpenDentalSync from './OpenDentalSync'
import Cloud9Sync from './Cloud9Sync'
import OrthoTracSync from './OrthoTracSync'
import OrthoTracV2Sync from './OrthoTracV2Sync'
import GreyfinchSync from './GreyfinchSync'
import ManualSync from './ManualSync'
import NextButton, { BackButton } from '../../common/NextButton'
import SchedulingWidgetSnippet from './SchedulingWidgetSnippet'

class Info extends Component {
  static propTypes = {
    pms: PropTypes.oneOf([
      'topsOrtho',
      'Dolphin',
      'Cloud9',
      'OrthoTrac',
      'OrthoTracV2',
      'OpenDental',
      'Greyfinch',
    ]),
    appointmentTypes: PropTypes.arrayOf(PropTypes.object),
    carestreamCustomers: PropTypes.arrayOf(PropTypes.object),
    onBack: PropTypes.func.isRequired,
    practiceId: PropTypes.string.isRequired,
    onNext: PropTypes.func.isRequired,
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
    doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
    handleApiError: PropTypes.func.isRequired,
    getAndSaveLocationList: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    setStepStatus: PropTypes.func.isRequired,
    getAndSaveDoctorsList: PropTypes.func.isRequired,
    createOrUpdateDoctor: PropTypes.func.isRequired,
    createOrUpdateLocation: PropTypes.func.isRequired,
    currentStep: PropTypes.number.isRequired,
    schedulingClient: PropTypes.bool,
    website: PropTypes.string,
    greyfinchIntegrationComplete: PropTypes.bool,
  }

  static defaultProps = {
    appointmentTypes: [],
    carestreamCustomers: [],
    pms: null,
    schedulingClient: false,
    website: null,
  }

  render() {
    const {
      appointmentTypes,
      currentStep,
      createOrUpdateDoctor,
      createOrUpdateLocation,
      carestreamCustomers,
      doctors,
      getAndSaveDoctorsList,
      getAndSaveLocationList,
      handleApiError,
      locations,
      onBack,
      onNext,
      pms,
      practiceId,
      schedulingClient,
      website,
      greyfinchIntegrationComplete,
    } = this.props

    const SyncScreen = (() => {
      switch (pms) {
        case 'topsOrtho':
          return TopsSync
        case 'Dolphin':
          return DolphinSync
        case 'Cloud9':
          return Cloud9Sync
        case 'OrthoTrac':
          return OrthoTracSync
        case 'OrthoTracV2':
          return OrthoTracV2Sync
        case 'OpenDental':
          return OpenDentalSync
        case 'Greyfinch':
          return GreyfinchSync
        default:
          return ManualSync
      }
    })()

    return (
      <div>
        <SyncScreen
          practiceId={practiceId}
          onError={handleApiError}
          locations={locations}
          doctors={doctors}
          getAndSaveLocationList={getAndSaveLocationList}
          getAndSaveDoctorsList={getAndSaveDoctorsList}
          carestreamCustomers={carestreamCustomers}
          createOrUpdateLocation={createOrUpdateLocation}
          createOrUpdateDoctor={createOrUpdateDoctor}
          clearError={this.props.clearError}
          setStepStatus={this.props.setStepStatus}
          step={currentStep}
          website={website}
        />
        {schedulingClient && website && (
          <SchedulingWidgetSnippet
            appointmentTypes={appointmentTypes}
            locations={locations}
            practiceId={practiceId}
            website={website}
            pms={pms}
          />
        )}
        <BackButton handleClick={onBack} />
        <NextButton
          isSubmit={false}
          isDisabled={!locations.length || (pms === 'Greyfinch' && !greyfinchIntegrationComplete)}
          handleClick={onNext}
        />
      </div>
    )
  }
}
export default Info



// WEBPACK FOOTER //
// ./src/AddPractice/Info/index.js